import { createBiLogger } from './create-logger';

export const biErrorLogger = createBiLogger({
  src: 94,
  evid: 837,
});
